import {GET_DATA_LOGIN_LOGIN, SET_DATA_LOGIN_LOGIN,LOGIN, LOGIN_SUCCEEDED, LOGIN_FAILED} from '../actions/actionTypes'
import {RequertLoginLoginFaileAction, GetDataLoginLoginSuccessAction, IsResultAction} from '../actions'

import { put, takeLatest} from 'redux-saga/effects'
import { Api } from './api'

function* GetDataLogin(){
    try{
        const DataLogin = yield Api.GetDataLoginFromApi();
        yield put(GetDataLoginLoginSuccessAction(DataLogin))
    }catch(error){
        yield put(RequertLoginLoginFaileAction(error))
    }
}
export function* watchGetDataLogin(){
    yield takeLatest(GET_DATA_LOGIN_LOGIN, GetDataLogin)
}


function* SetDataLogin(action){
    try{
        const isResult = yield Api.SetDataLoginFromApi(action.DataLogin);
        if(isResult)
        {
            yield put(IsResultAction(isResult))
        }
        else
        {
            yield put(RequertLoginLoginFaileAction("error"))
        }
    }catch(error){
        yield put(RequertLoginLoginFaileAction(error))
    }
}
export function* watchSetDataLogin(){
    yield takeLatest(SET_DATA_LOGIN_LOGIN, SetDataLogin)
}
function* Login(actions){
    try{
        const resultLogin = yield Api.LoginFromApi(actions.token);
         yield put({ type: LOGIN_SUCCEEDED, resultLogin: resultLogin })
    }catch(error){
        yield put({ type: LOGIN_FAILED, error })
    }
}
export function* watchLogin(){
    yield takeLatest(LOGIN, Login)
}